import { TaskTemplate } from 'aos-services/src/services/tasks/types/task/TaskTemplate'
import {
    TerminalTask,
    TerminalTaskType,
    translateTerminalTaskType,
} from 'aos-services/src/services/tasks/types/task/TerminalTask'
import { PropsListEntry } from 'aos-ui/src/components/list/PropsList'
import { TFunction } from 'i18next'

export const terminalTaskPropertyList =
    (translate: TFunction) =>
    (t: TerminalTask | TaskTemplate<TerminalTask>): PropsListEntry[] => {
        const common = [
            [
                'tasks.task-preview.terminal-task-type',
                t.terminalTaskType ? translateTerminalTaskType(translate)(t.terminalTaskType) : '-',
            ],
        ] as PropsListEntry[]

        switch (t.terminalTaskType) {
            case TerminalTaskType.HeatingWires:
                return [
                    ...common,
                    ['tasks.task-preview.license-plate', t.licensePlate],
                    ['tasks.task-preview.vehicle-location', t.vehicleLocation],
                ]
            case TerminalTaskType.CUSSParkingMeters:
                return [
                    ...common,
                    ['tasks.task-preview.paper-supplement', t.paperSupplement],
                    ['tasks.task-preview.observation', t.observation],
                ]
            default:
                return [...common]
        }
    }
